let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f9QHk")).then(() => parcelRequire('e14IX'));